<template>
    <div>
        <GridPage
            :form-default="{
                level: '100',
                status: 'pending',
            }"
            :filters-default="{
                level: '',
                status: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'level',
                    title: '権限',
                    options: [
                        { text: '全て', value: '' },
                        { text: 'なし', value: '000' },
                        { text: '一般', value: '100' },
                        { text: '編集者', value: '200' },
                        { text: '管理者', value: '300' },
                    ],
                },
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '準備', value: 'pending' },
                        { text: '稼働', value: 'activated' },
                        { text: '停止', value: 'suspended' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        {
                            text: '▲ 名前',
                            value: 'name',
                        },
                        { text: '▼ 名前', value: '-name' },
                    ],
                },
            ]"
            filters-q-placeholder="名前、よみ、メール"
            form-modal-id="user"
            search-action="user/index"
            >
            <template v-slot:form="{ form, init }">
                <User :model="form" :init="init"></User>
            </template>

            <template>
                <b-col md="6"> 名前 </b-col>
                <b-col md="6"> メール </b-col>
            </template>

            <template v-slot:column="{ item }">
                <b-col md="6" class="align-self-center">
                    <p class="mb-1">
                    <b-badge
                        :variant="$store.getters['user/level2variant'](item.level)"
                        >
                        {{
                        trans.labels[
                        'users.level.' + item.level
                        ]
                        }}
                    </b-badge>
                    </p>
    
                    <ruby v-if="item.last_name">
                        {{ item.last_name }}
                        <rt v-if="item.last_kana">
                        {{ item.last_kana }}
                        </rt>
                    </ruby>
    
                    <ruby v-if="item.first_name">
                        {{ item.first_name }}
                        <rt v-if="item.first_kana">
                        {{ item.first_kana }}
                        </rt>
                    </ruby>
                </b-col>
    
                <b-col md="6" class="align-self-center">
                    <template v-if="item.email">
                    <i class="far fa-fw fa-envelope"></i>
                    <b-link :href="'mailto:' + item.email">{{ item.email }}</b-link>
                    </template>
                </b-col>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import User from '@/components/User.vue'

export default {
    components: {
        GridPage,
        User,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
    },
}
</script>

